import React, { useState } from "react";
import styled from "styled-components";
import { Button, TextArea } from "@blueprintjs/core";

const DEFAULT_IGNORES = `# Ignore git items
.gitignore
.git/
:include .gitignore

# Common large directories
node_modules/
build/
dist/
vendor/
env/
.env/
venv/
.venv/
*.min.js

# Common test directories
test/
tests/

# Semgrep rules folder
.semgrep
`;

type Props = {
  ignoredPaths: string[] | null;
  setIgnoredPaths: (paths: string[]) => void;
};

const SaveButtonDiv = styled.div`
  margin-top: var(--global-spacing-m);
  display: flex;
  justify-content: flex-end;
`;

const IgnoredTextArea = styled(TextArea)`
  background-color: var(--global-light-gray);

  :focus {
    background-color: white;
  }
`;

export const IgnoredPathsEditor: React.FC<Props> = ({
  ignoredPaths,
  setIgnoredPaths,
}) => {
  const inputValue = ignoredPaths ? ignoredPaths.join("\n") : "";
  const [editedInput, setEditedInput] = useState<string>(inputValue);

  const parseIgnoredPaths = (): string[] => {
    const splitInput = editedInput.split("\n");
    // get rid of all whitespace
    return splitInput.map((p) => p.replace(/\s+/g, ""));
  };

  return (
    <div>
      <IgnoredTextArea
        fill
        value={editedInput}
        placeholder={DEFAULT_IGNORES}
        style={{ height: "200px" }}
        onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) => {
          setEditedInput(event.target.value);
        }}
      />
      {editedInput !== inputValue && (
        <SaveButtonDiv>
          <Button
            intent="primary"
            outlined
            onClick={() => setIgnoredPaths(parseIgnoredPaths())}
          >
            Save path ignores
          </Button>
        </SaveButtonDiv>
      )}
    </div>
  );
};
